import React, { useState } from "react";
import { FaDownload } from "react-icons/fa";
import { Alert, Button, Spinner } from "reactstrap";
import relatoriosService from "../../../api/relatorios";
import { errorToString, pushBlobToDownload } from "../../../helpers/funcoes";
import { Titulo } from "../../Titulo";
import { RelatoriosAbas } from "../RelatorioAbas";

export function RelatoriosPlanilhaDeNotasPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  const onBaixarClick = () => {
    setLoading(true);
    setError(undefined);
    relatoriosService
      .planilhaDeNotas()
      .then((res) => pushBlobToDownload("Notas.xlsx", res))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <RelatoriosAbas />
      <Titulo text="Planilha de Notas" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <div className="text-center">
        <Button color="primary" onClick={onBaixarClick} disabled={loading}>
          Baixar Planilha <FaDownload />
        </Button>
        {loading && (
          <div className="mt-4">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
}
